'use client';

import { IconButton } from '@chakra-ui/react';
import { MdArrowBack } from 'react-icons/md';
import { useFilters } from '~/hooks/useFilters';
import { useHomesStore } from '~/store/useHomesStore';
import { NestedSearch } from '@habity/types';

interface BackButtonProps {
  filterKeysToRemove: (keyof NestedSearch)[];
  clearLocations?: boolean;
}

export const SuggestionBackButton = ({
  filterKeysToRemove,
  clearLocations,
}: BackButtonProps) => {
  const { performSearch } = useFilters();
  const setLocations = useHomesStore((state) => state.setLocations);

  const handleBack = () => {
    const filtersToRemove: Partial<NestedSearch> = {};
    filterKeysToRemove.forEach((key) => {
      (filtersToRemove as Record<string, unknown>)[key] = undefined;
    });

    if (clearLocations) {
      setLocations([]);
    }

    performSearch({ filters: filtersToRemove });
  };

  return (
    <IconButton
      aria-label="Gå tillbaka"
      icon={<MdArrowBack size={20} />}
      variant="ghost"
      size="sm"
      rounded="full"
      color="blackAlpha.700"
      _hover={{ backgroundColor: 'blackAlpha.100' }}
      onClick={handleBack}
      flexShrink={0}
    />
  );
};
